import styled from "styled-components";

export const DEFeatureSection = styled.section`
  position: relative;
  width: 100%;
  //height: 75vh;
  //max-height: 600px;
  padding-bottom: 2rem;
  overflow: hidden;

  color: white;

  .gatsby-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    ::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
    }
  }

  .content {
    position: relative;
    margin: 5rem auto 0;
    //max-width: 1000px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  h1 {
    color: inherit;
    font-size: 2.6rem;
    margin-bottom: 1rem;
  }

  .cta-stack {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 0.5rem;

    > * {
      width: 100%;
    }
  }

  @media only screen and (min-width: 768px) {
    .gatsby-image-wrapper::after {
      background: linear-gradient(to right, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 25%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
    }

    .content {
      margin-top: 6rem;

      > * {
        width: 50%
      }
    }

    .cta-stack {
      align-items: flex-start;
      padding-left: 1rem;
      width: 18rem;
    }
  }
`

export default DEFeatureSection;
